import type { ReactNode } from "react"

interface ConsiderationCardProps {
  /** Emoji, short string, or React element rendered inside the icon circle */
  icon?: ReactNode
  /** Feature/consideration title */
  title: string
  /** Short description (1-2 sentences) */
  description: string
  /** Additional classes on the outer wrapper */
  className?: string
}

/**
 * ConsiderationCard — Key Consideration info card used in buying guide sections.
 *
 * Left blue accent bar + icon circle + title/description.
 * Non-interactive display card highlighting buying considerations.
 */
export function ConsiderationCard({
  icon,
  title,
  description,
  className = "",
}: ConsiderationCardProps) {
  return (
    <div
      className={`bg-white rounded-xl border border-gray-100 overflow-hidden flex ${className}`}
    >
      <div className="w-1.5 bg-[#0469f0] flex-shrink-0" />
      <div className="p-5 flex flex-col flex-grow">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-lg bg-[#0469f0]/10 flex items-center justify-center flex-shrink-0">
            <span className="text-base">{icon || '📋'}</span>
          </div>
          <h3 className="font-bold text-gray-900 text-base">{title}</h3>
        </div>
        <p className="text-sm text-gray-500 leading-relaxed flex-grow">{description}</p>
      </div>
    </div>
  )
}
